<div class="modal-wrap">
  <span *ngIf="tenant.current.id !== 'feelen'" class="material-symbols-outlined">
    warning
  </span>
  <img *ngIf="tenant.current.id === 'feelen'" src="assets/logos/feelen-logo.png" class="feelen-logo" alt="feelen"/>
  <h1>{{'PHONE_WARNING.TEXT' | translate}}</h1>
</div>
